export class SubscriptionForRegister {
    constructor() {
        this.APIId = 0;
        this.UserId = 0;
        this.ProjectName = "";
    }

    UserId: number;
    APIId: number;
    ProjectName: string;
}



